import React from 'react';
import { motion } from 'motion/react';
import PartnersMarquee from '../ui/partners-marquee';
import { Building2, Users, Trophy, Target } from 'lucide-react';

const TrustedBySection = () => {
  const stats = [
    {
      icon: <Building2 className="w-5 h-5" />,
      value: '18+',
      label: '완료 프로젝트',
      color: 'from-zinc-600 to-zinc-700',
    },
    {
      icon: <Users className="w-5 h-5" />,
      value: '2,500+',
      label: 'DAU',
      color: 'from-zinc-700 to-zinc-800',
    },
    {
      icon: <Trophy className="w-5 h-5" />,
      value: '5.0',
      label: '숨고 평점',
      color: 'from-zinc-700 to-zinc-900',
    },
    {
      icon: <Target className="w-5 h-5" />,
      value: '4년+',
      label: '경력',
      color: 'from-zinc-600 to-zinc-800',
    },
  ];

  return (
    <section className="py-24 px-4 bg-muted/20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-muted/5 to-transparent" />

      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1, duration: 0.5 }}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-muted/50 backdrop-blur-sm border border-border mb-6"
          >
            <span className="text-sm font-medium text-muted-foreground">
              검증된 파트너
            </span>
          </motion.div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
            <span className="text-foreground">신뢰할 수 있는</span>
            <span className="text-zinc-400"> 기술 파트너</span>
          </h2>
          <p className="text-lg text-foreground/70 max-w-2xl mx-auto">
            다양한 산업 분야의 클라이언트와 함께 성장하고 있습니다
          </p>
        </motion.div>

        {/* Stats Grid */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-16 max-w-4xl mx-auto"
        >
          {stats.map((stat, index) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1, type: "spring", stiffness: 100 }}
              whileHover={{ y: -5 }}
              className="relative"
            >
              <div className="relative bg-zinc-950/50 backdrop-blur-sm p-6 rounded-2xl border border-zinc-800/50 overflow-hidden group hover:border-zinc-700/50 hover:bg-zinc-950/70 transition-all duration-300">
                <div className="absolute inset-0 bg-gradient-to-br from-zinc-800/10 to-transparent opacity-50" />
                <div className="relative">
                  <div className="flex flex-col items-center text-center space-y-3">
                    <div className="text-zinc-400 group-hover:text-zinc-300 transition-colors">
                      {stat.icon}
                    </div>
                    <div className="text-3xl md:text-4xl font-bold text-white">
                      {stat.value}
                    </div>
                    <p className="text-xs font-medium text-zinc-500 uppercase tracking-wider">
                      {stat.label}
                    </p>
                  </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-zinc-800/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Partners Marquee */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          <div className="text-center mb-12">
            <h3 className="text-lg font-semibold text-foreground mb-2">
              함께한 클라이언트
            </h3>
            <p className="text-sm text-muted-foreground">
              다양한 분야의 프로젝트를 성공적으로 수행했습니다
            </p>
          </div>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-zinc-800/20 to-transparent blur-xl" />

            <PartnersMarquee
              speed={40}
              className="py-8 relative"
              partners={[
                { id: '1', name: 'BBQ' },
                { id: '2', name: '우쿠야' },
                { id: '3', name: '고려대학교 대학원' },
                { id: '4', name: '디데이 프로그램' },
                { id: '5', name: '투두날다' },
                { id: '6', name: '글로벌 구인구직' },
                { id: '7', name: '부동산 CRM' },
                { id: '8', name: '대출 중계 플랫폼' },
                { id: '9', name: '오디션 서비스' },
                { id: '10', name: '문자 전송' },
                { id: '11', name: '롤 전적검색' },
                { id: '12', name: '정책자금' },
              ]}
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustedBySection;
